module.exports = {
  "IDMClientOptions": {
    "externalAuth": false,
    "cookiesEndpoint": "https://auth-dev.bccsa-services.ca",
    "apiEndpoint": "https://api-auth-dev.bccsa-services.ca",
    "roles": {
      "USER": "59a72bbd-9a43-427e-9c92-afd74ab19431",
      "ADMIN": "MY-APP-ADMIN-ROLE",
      "ROOT": "59a72bbd-9a43-427e-9c92-afd74ab19433"
    },
    "partitions": {
      "PERSONAL": "ca.bccsa.personal",
      "PROFESSIONAL": "ca.bccsa.professional"
    }
  },
  "IncludesStageOnName": true,
  "Stage": "dev",
  "ApplicationRecaptchaKey": "6LfO17sUAAAAADbEcJD9brTVgjw5uPW5h495bHwt",
  "ApplicationAdvancedSearchDisabled": false,
  "ApplicationRoutes": {
    "login": "/",
    "homepage": "/",
    "register": "/register",
    "registrationConfirmation": "/registrationConfirmation/:id/:id2",
    "registrationConfirmationMail": "/registrationConfirmation/:id",
    "registrationConfirmationReset": "/registrationConfirmation/reset/:id",
    "resetPassword": "/resetPass/:id",
    "resetPasswordRaw": "/resetPass/",
    "resetPasswordConfirmation": "/resetPass/confirm/:id",
    "setupPassword": "/setupPass/:id/:id2",
    "user": "/user/:id",
    "profile": "/user",
    "users": "/users",
    "applications": "/apps",
    "application": "/app/:id",
    "role": "/app/:id/role/:id2",
    "accessToken": "/app/:id/accessToken/:id2",
    "partitionACLs": "/acls",
    "partitionACL": "/acl/:id",
    "authError": "/authError",
    "smsMFA": "/smfa",
    "contactAdmin": "mailto:support@ikonintegration.com"
  },
  "ThemeDomainsMapping": {
    "*.bccsa-services.ca": {
      "themeKey": "bccsa",
      "adminRole": "d814d866-13e_BC___Students_Portal",
      "userRole": "bfbdf576-293_BC___Students_Portal",
      "idmKey": "e1440e25-f920-4114-8ae9-52d734bd0baf",
      "idmSecret": "6d81316b-2ea6-4f32-bb7c-90ea9e8be6ce",
      "idmExternalAuthDomain": "auth-dev.bccsa-services.ca"
    },
    "*.constructionsafety.ca": {
      "themeKey": "csam",
      "adminRole": "191920e9-973_MB___Students_Portal",
      "userRole": "5e33e563-bab_MB___Students_Portal",
      "idmKey": "333e5983-8491-4177-ad10-c2f8f288d49e",
      "idmSecret": "14793f38-be0e-4b3e-924a-a827074d52f1",
      "idmExternalAuthDomain": "auth-dev.bccsa-services.ca"
    },
    "localhost:3000": {
      "themeKey": "csam",
      "adminRole": "191920e9-973_MB___Students_Portal",
      "userRole": "5e33e563-bab_MB___Students_Portal",
      "idmKey": "333e5983-8491-4177-ad10-c2f8f288d49e",
      "idmSecret": "14793f38-be0e-4b3e-924a-a827074d52f1",
      "idmExternalAuthDomain": "auth-dev.bccsa-services.ca"
    }
  },
  "DatadogOptions": {
    "applicationId": "a8039f15-8b00-4cae-86af-e5f95cd24ece",
    "clientToken": "pub1e0e6e2f2186d5b5c5d0b66627a2481f",
    "site": "datadoghq.com",
    "service": "idm-fe",
    "env": "development",
    "sampleRate": 100,
    "trackInteractions": true,
    "defaultPrivacyLevel": "allow"
  }
}